import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/bonuses";
export function Bonuses() {
  return <section className="bg-navy-950 px-4 py-16 text-white sm:px-6 sm:py-20" data-id="element-136" data-mp="1clpk2p8rc6uk">
      <div className="mx-auto max-w-5xl" data-id="element-137" data-mp="18km6k9e6mmwi">
        <SectionHeading tone="dark" kicker="Your 5 exclusive professional bonuses" title="Five additional resources to help you put the framework into practice." intro="Your purchase also includes five complementary educational resources." data-id="element-138" data-mp="18hhw4ua4iuxe" />

        <div className="mt-12 space-y-8" data-id="element-139" data-mp="1w7c8laqj6hh4">
          {bonuses.map(b => <article key={b.number} className="-mx-4 overflow-hidden bg-white text-ink sm:mx-0 sm:rounded-3xl md:grid md:grid-cols-2" data-id="element-140" data-mp="1r9anyldgia3j">
              <div className="bg-white" data-id="element-141" data-mp="funmkseuhfyp">
                <img src={b.image} alt={`${b.title} digital mockup`} className="block h-auto w-full md:h-full md:object-cover" loading="lazy" data-id="element-142" data-mp="ftm07rsdp71o" />
              </div>
              <div className="flex flex-col p-5 sm:p-7" data-id="element-143" data-mp="15ti7c7zvgvdd">
                <p className="inline-flex w-fit items-center gap-1.5 rounded-full bg-gold px-3.5 py-1 font-display text-lg font-extrabold uppercase tracking-wide text-navy-950" data-id="element-144" data-mp="15v31vxm6seb8">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="w1m1ubvgi2z4" />
                  Bonus #{b.number}
                </p>
                <h3 className="mt-3 font-display text-3xl font-extrabold uppercase leading-[1.02]" data-id="element-146" data-mp="10vqe9anhr37l">
                  {b.title}
                </h3>
                <p className="mt-2 text-lg font-semibold leading-snug text-brand" data-id="element-147" data-mp="r5443vyjn4wa">{b.headline}</p>
                <p className="mt-3 leading-relaxed text-ink-muted" data-id="element-148" data-mp="d5chj6tyog6o">{b.intro}</p>

                <p className="mt-5 text-sm font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-149" data-mp="i3xi57d4l1vn">
                  Inside this resource
                </p>
                <ul className="mt-2.5 space-y-2" data-id="element-150" data-mp="2juo9tt1ffwwe">
                  {b.items.map(item => <li key={item} className="flex items-start gap-2.5 leading-snug" data-id="element-151" data-mp="2f0jyyyp1j4q1">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-152" data-mp="2b0rnoe89ikgz" />
                      {item}
                    </li>)}
                </ul>
                {b.note && <p className="mt-3 text-xs italic leading-relaxed text-ink-muted" data-id="element-153" data-mp="32p3adn3dzxmc">{b.note}</p>}

                <div className="mt-auto pt-6" data-id="element-154" data-mp="2ynq1f44zzeb7">
                  <div className="flex items-center justify-between gap-3 rounded-2xl bg-success-soft px-4 py-3" data-id="element-155" data-mp="2tpybugrts4a6">
                    <span className="text-sm font-semibold text-ink-muted" data-id="element-156" data-mp="2oqv58rw75q03">
                      Suggested value: <span className="line-through" data-id="element-157" data-mp="1icm1ro5h2pfk">${b.value}</span>
                    </span>
                    <span className="text-sm font-extrabold uppercase text-success" data-id="element-158" data-mp="1dbg8np7wh05i">Included free</span>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12 text-center" data-id="element-159" data-mp="188femq4f9tl5">
          <h3 className="font-display text-4xl font-extrabold uppercase leading-tight" data-id="element-160" data-mp="1d6qt5e5nws9p">
            Yes! I want all 5 professional bonuses
          </h3>
          <p className="mt-2 text-lg text-white/80" data-id="element-161" data-mp="1hz0cucg6ow3j">
            Receive the complete collection with all five complementary resources.
          </p>
          <CTAButton className="mt-6" tone="dark" label="Get everything for just $27 USD" note="Digital product · One-time payment" data-id="element-162" data-mp="1qxvjfpn5487d" />
        </div>
      </div>
    </section>;
}